import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { GlobalServiceProvider } from '..';

/*
  Generated class for the SettingsServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SettingsServiceProvider {
  baseUrl: String = this.globalServiceProvider.appConfig.BaseApiUrl;
  constructor(public http: Http,
    public globalServiceProvider: GlobalServiceProvider) {
    console.log('Hello SettingsServiceProvider Provider');
  }
  
  getCustomers() {
    let result = null;
    return this.http
      .get(this.baseUrl + '/api/customers')
      .toPromise()
      .then(data => {
        result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/providers/settings-service/settings-service.ts